<template>
    <div>
        <div class="mark-gray"></div>
        <div class="box p-2">
            <div class="row">
                <div v-if="cta" class="col-lg-2 col-md-3 col-3 d-flex">
                    <input-checkbox 
                        v-model="cta.isChecked"
                        :value-checked="true" 
                        :value-unchecked="false"
                        class="ml-3" 
                    >
                    </input-checkbox>
                    <div class=" d-flex flex-column">
                        <label class="lbl-list">Nr Documento</label>
                        <span class="data-list">{{ cta.doc }}</span>
                    </div>
                </div>
                <div v-if="cta" class="col-lg-1 col-md-1 col-3 d-flex flex-column">
                    <label class="lbl-list">Parcela</label>
                    <span class="data-list">{{ cta.parcela }}</span>
                </div>
                <div v-if="cta" class="col-lg-2 col-md-2 col-3 d-flex flex-column">
                    <label class="lbl-list">Data Emissão</label>
                    <span class="data-list">{{ cta.data | formatData }}</span>
                </div>
                <div v-if="cta" class="col-lg-2 col-md-2 col-3 d-flex flex-column">
                    <label class="lbl-list">Data Vencimento</label>
                    <span class="data-list">{{ cta.dtv | formatData }}</span>
                </div>
                <div v-if="cta" class="col-lg-3 col-md-3 col-3 d-flex flex-column">
                    <label class="lbl-list">Nome</label>
                    <span class="data-list">{{ cta.nome }}</span>
                </div>
                <div v-if="cta" class="col-lg-2 col-md-2 col-3 d-flex flex-column">
                    <label class="lbl-list">Valor do Documento</label>
                    <span class="data-list">{{ cta.vlr | formatValue(2) }}</span>
                </div>
            </div>
            <div class="row" v-if="!cta">
                <div class="col">
                    <span class="data-list">Não Há Títulos a Serem Vinculados</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        cta: {
            type: Object,
            require: true
        },
    },
    watch: {
        'cta.isChecked': function(newValue, oldValue) {
            this.$emit('change', newValue)
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/forms/receber-list-cnab.vue